import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createI18n } from "vue-i18n";
import * as Sentry from "@sentry/vue";

// noinspection JSCheckFunctionSignatures
const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://97b75a2ebce6d0a1a03671133f263be8@o4510759476920320.ingest.de.sentry.io/4511026155290704",
  environment: import.meta.env.MODE, // development, production or --mode
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration({
      // If you need to customize masking, ignoring and blocking in replays, check the docs.
      // https://docs.sentry.io/platforms/javascript/session-replay/privacy/
      // There are special mask/ignore/block CSS selector and class attributes that can be used without change here.
      maskAllText: false,
      maskAllInputs: false,
    }),
    // If you don't change trackingOptions, it's unnecessary to re-define vueIntegration
  ],
  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Filter Spans
  ignoreSpans: [
    // OpenStreetMap tiles
    // {op: /^resource/, name: /openstreetmap\.org/},
    // Resource fetch for images, CSS, script, png/icons, stripe iframe
    { op: /^resource.(img|css|script|other|iframe)$/ },
  ],
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/api\.barracuda\.rossinienergy\.com\//, /^https:\/\/api\.charge\.re\//],
  // Session Replay
  replaysSessionSampleRate: 0, // Disable it, too costly
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Logs
  enableLogs: true
});

import { SUPPORTED_LANGUAGES } from './i18n_config';

function navigator_lang(lang) {
  // const lang = navigator.language || null;
  if (lang === null) {
    lang = navigator.language || null;
  }
  if (lang === null) {
    return null;
  }
  const tmp = lang.slice(0, 2).toLowerCase();
  if (!Object.keys(SUPPORTED_LANGUAGES).includes(tmp)) {
    return null;
  }
  return tmp;
}

let locale = navigator_lang(localStorage.getItem("superadmin_language_bufu") ?? null) || "en";
localStorage.setItem("superadmin_language_bufu", locale);
const i18n = createI18n({
  locale,
  legacy: false,

  globalInjection: true,
  allowComposition: true,

  messages: { en: {}, it: {}, fr: {}, }
});

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import VueExcelEditor from 'vue3-excel-editor';

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    //
  },
});

// Pinia
import { createPinia } from 'pinia';
import { createSentryPiniaPlugin } from "@sentry/vue";

const pinia = createPinia();
pinia.use(createSentryPiniaPlugin());

// Leaflet
import "leaflet/dist/leaflet.css";

app.use(vuetify)
  .use(router)
  .use(pinia)
  .use(i18n)
  .use(VueExcelEditor)
  .mount('#app');
